module.exports = __webpack_public_path__ + "img/gsb11.85e070f5.png";